import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import * as api from "../../../api/index";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import EditDocType from "./EditDocTypes";
import { getDocTypes } from "actions/docTypes.action";
import DocTypeList from "./DocTypesList";

const DocTypes = () => {
  const [addnewform, setaddnewform] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const closeform = () => {
    setaddnewform(false);
  };

  const handleSubmit = async (e) => {
    try {
      setIsSubmitting(true);
      await api.addNewDocType({
        active: true,
        ...e,
      });
      dispatch(getDocTypes());
      setaddnewform(false);
      toast.success("Document Type Added");
    } catch (error) {
      toast.error("Error Occured");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <>
        <div className="row">
          <div className="col-lg-10 col-md-8"></div>
          <Button
            className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${
              styles[`button`]
            }`}
            onClick={() => {
              setaddnewform(true);
            }}
          >
            Add <br></br>
            Document Type
          </Button>
        </div>
        <div className={`row mx-auto mt-3 col-12 col-xl-9 col-xxl-5`}>
          <DocTypeList />
        </div>
      </>
      {addnewform && (
        <EditDocType
          cancelEdit={closeform}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default DocTypes;
